var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-light px-3"},[(_vm.returnDraftDto.ReturnDraftType === 'Surplus')?_c('SurplusReturnPartAdd',{attrs:{"return-draft-dto":_vm.returnDraftDto}}):_c('ExpressReturnPartAdd',{attrs:{"return-draft-dto":_vm.returnDraftDto}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }